import type { Member, User, UserDetails, UserGeneralInfo, Workspace } from '@apiTypes'
import type { SelectOption } from '@/types/select'

type NamedPerson = User | UserDetails | UserGeneralInfo

export function formatUser(user: User | UserDetails | UserGeneralInfo | undefined | null): string {
  if (user?.firstName || user?.lastName)
    return formatUserName(user)

  return user?.email || ''
}

export function formatUserName(user: NamedPerson | undefined | null): string {
  return [user?.firstName, user?.lastName].filter(val => !!val).join(' ')
}

function toUserOption(user: UserGeneralInfo): SelectOption {
  return { value: user.id, label: formatUser(user) }
}

export function responsibleUserOptions(users: UserGeneralInfo[], followerIds?: number[] | null): SelectOption[] {
  return users
    .filter(user => !followerIds?.includes(user.id))
    .map(toUserOption)
}

export function followerUserOptions(
  users: UserGeneralInfo[],
  responsibleUserId: number | null | undefined,
  currentUserId: number | undefined,
): SelectOption[] {
  // `||` on purpose: clearing the select leaves '' in the field
  const excludedUserId = responsibleUserId || currentUserId

  return users
    .filter(user => user.id !== excludedUserId)
    .map(toUserOption)
}

export function mapWorkspaceOnMembers(workspace: Workspace, members: Member[]): Member[] {
  return (members || []).map(member => mapWorkspaceOnMember(workspace, member))
}

function mapWorkspaceOnMember(workspace: Workspace, member: Member): Member {
  if (workspace.id === member.workspace.id)
    return { ...member, workspace: { ...member.workspace, name: workspace.name } }

  return member
}
